import PropTypes from 'prop-types';
import React from 'react';
import translate from '../../translate';
import { connect as connectR } from 'react-redux';
import {
    LoadAppliancesByLocation,
    resetApplianceRequestStates,
} from '../../../store/applianceSlice';
import {
    REQUEST_FAILURE,
    REQUEST_PENDING,
} from '../../../store/network/managedRequest';
import RefreshButton from '../../main/refresh-button';
import { PbRequest } from '../../../store/pbRequest';

class ApplianceStatusForm extends React.Component {
    static propTypes = {
        strings: PropTypes.object,
        locationId: PropTypes.number.isRequired,
        applianceId: PropTypes.number.isRequired,
        appliancesByLaundryRoom: PropTypes.shape({}).isRequired,
        LoadAppliancesByLocation: PropTypes.func.isRequired,
        resetApplianceRequestStates: PropTypes.func.isRequired,
        fetchRequest: PropTypes.shape({
            status: PropTypes.string,
            errors: PropTypes.arrayOf(PropTypes.string),
        }).isRequired,
    };

    getAppliance = () => {
        const locationId = this.props.locationId;
        const applianceId = this.props.applianceId;
        if (locationId && applianceId) {
            const byApplianceId =
                this.props.appliancesByLaundryRoom[locationId] || {};
            return byApplianceId[applianceId];
        }
        return null;
    };

    maybeRenderError = (request) => {
        if (request.status !== REQUEST_FAILURE) {
            return null;
        }
        return (
            <div className="alert alert-danger">
                {this.props.strings.generalError}
            </div>
        );
    };

    reload = () => {
        const locationId = this.props.locationId;
        if (locationId) {
            this.props.resetApplianceRequestStates();
            this.props.LoadAppliancesByLocation(locationId);
        }
    };

    renderRefreshAction = () => {
        const inProgress = this.props.fetchRequest.status === REQUEST_PENDING;

        return (
            <div>
                <RefreshButton onClick={this.reload} loading={inProgress} />
                {this.maybeRenderError(this.props.fetchRequest)}
            </div>
        );
    };

    render() {
        function renderValue(value) {
            return (
                <div className="form-line">
                    <input
                        type="text"
                        className="form-control"
                        id=""
                        value={value}
                        disabled
                    />
                </div>
            );
        }

        const appliance = this.getAppliance();
        if (!appliance) {
            return <div />;
        }

        const stateDisplay = appliance.enabled
            ? this.props.strings.applianceState[appliance.state] || '-'
            : this.props.strings.disabled;

        return (
            <div className="form-group">
                <label htmlFor="">{this.props.strings.state}</label>
                {renderValue(stateDisplay)}
                <label htmlFor="">
                    {this.props.strings.operationalStateLabel}
                </label>
                {renderValue(
                    this.props.strings.operationalState[
                        appliance.operational_state
                    ] || '-'
                )}
                {this.renderRefreshAction()}
            </div>
        );
    }
}

export default connectR(
    (store) => ({
        appliancesByLaundryRoom: store.appliance.appliancesByLaundryRoom,
        fetchRequest: store.pbRequest[PbRequest.FETCH_APPLIANCES],
    }),
    {
        LoadAppliancesByLocation,
        resetApplianceRequestStates,
    }
)(translate('ApplianceStatusForm')(ApplianceStatusForm));
